<div class="container">
  <h1 class="titulo-campana">Campaña {{ selectedCampaign?.name || '' }}</h1>
  <!-- Mostrar dropdown solo si hay más de una campaña -->
  @if (campaigns.length > 0) {
    <div class="controls">
      <app-campana-select
        [options]="campaignOptions"
        [selected]="selectedCampaignOption"
        (selectionChange)="onCampaignSelect($event)"
        placeholder="Seleccione una campaña">
      </app-campana-select>
    </div>
  }

  @if (selectedCampaignOption) {
    @if (cardData$ | async; as cols) {
      <div class="class-row">
        <div class="class-column">
          @for (item of cols[0]; track item.subtitulo) {
            <app-card-campana-component
              [titulo]="item.titulo"
              [subtitulo]="item.subtitulo"
              [icon]="item.icon"
              [colorIcon]="item.colorIcon"
              (click)="item.subtitulo === 'Cuestionarios respondidos' && goToResultados()"
              [ngClass]="{'clickable-card': item.subtitulo==='Cuestionarios respondidos'}">
            </app-card-campana-component>
          }
        </div>

        <div class="class-column">
          @for (item of cols[1]; track item.subtitulo) {
            <app-card-campana-component
              [titulo]="item.titulo"
              [subtitulo]="item.subtitulo"
              [icon]="item.icon"
              [colorIcon]="item.colorIcon"
              (click)="item.subtitulo === 'Cuestionarios respondidos' && goToResultados()"
              [ngClass]="{'clickable-card': item.subtitulo==='Cuestionarios respondidos'}">
            </app-card-campana-component>
          }
        </div>

        <div class="class-column">
          @if (percentageCard$ | async; as pc) {
            <app-card-campana-porcentaje-component
              class="card-larga"
              [titulo]="pc.titulo"
              [subtitulo]="pc.subtitulo"
              [imagen]="pc.imagen"
              [colorIcon]="pc.colorIcon"
              [percentage]="pc.percentage">
            </app-card-campana-porcentaje-component>
          }
        </div>
      </div>
    }


    @if (tabla) {
      <div class="tabla-campana">
        <h2>{{ campanaContent()?.titleTable }}</h2>
        <hr class="linea-separadora">
        <table>
          <tbody>
          <tr>
            <td>{{ campanaContent()?.campaignStartDateLabel }}</td>
            <td>{{ tabla.fechaInicio }}</td>
          </tr>
          <tr>
            <td>{{ campanaContent()?.campaignEndDateLabel }}</td>
            <td>{{ tabla.fechaFin }}</td>
          </tr>
          <tr>
            <td>{{ campanaContent()?.campaignDurationLabel }}</td>
            <td>{{ tabla.duracionTotal }} días</td>
          </tr>
          <tr>
            <td>{{ campanaContent()?.campaignResponsibleLabel }}</td>
            <td>{{ tabla.responsable }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    }
  }
  @else {
    <app-empty-state [message]="messageCampana"></app-empty-state>
  }
</div>


